<template>
  <div class="">
    <div class="condition clearfix">
      <el-form :inline="true" :model="conditions" class="demo-form-inline clearfix">
        <div class="clearfix" style="margin-bottom: 10px;">
          <!-- search start-->
          <el-form-item class="tinp" label="调出货位：">
            <el-select @change="selectchange1" filterable value-key="positioncode" v-model="conditions.houtpositionname" clearable placeholder="请选择调出货位" style="width:100%;" auto-complete="off">
              <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="tinp" label="调入货位：">
            <el-select @change="selectchange2" filterable value-key="positioncode" v-model="conditions.hinpositionname" clearable placeholder="请选择调入货位" style="width:100%;" auto-complete="off">
              <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" class="" size="small" icon="el-icon-search" @click="onParamChange">搜索</el-button>
          <el-button type="primary" class="fr" size="small"   @click="addlist">新增调整</el-button> 
          <el-button type="primary" class="fr" size="small"  @click="exportlist">导出货位调整单</el-button> 
        </div>
      </el-form>
      <!-- tablelist start -->
      <div class="tablebox" style="margin-top: 0px;">
        <table style="width:100%;margin-bottom: 10px" v-for="(item,index) in tableList">
          <tr style="border: 1px solid #56B8AA;background:#fff;color: #333;height:45px">
            <th :id="item.vbillcode" style="width:2rem;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(item,index)">
              <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':item.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i></th>
            <th colspan="11">
              <span class="fl tabletitle">货位调整单号：{{item.vbillcode}}</span>
              <span class="fl tabletitle">总部调整单号：{{item.vdef1}}</span>
              <span class="fl tabletitle">调整日期：{{item.dbilldate}}</span>
              <span class="fr tabletitle">调出货位：{{item.houtpositionname}}</span>
              <span class="fr tabletitle">调入货位：{{item.hinpositionname}}</span>
              <!-- <span class="fl tabletitle">仓库：{{item.cinstordocid}}</span> -->
              <!-- <span class="fr tabletitle">制单人：{{item.billmaker}}</span> -->
              <!-- <span class="fr tabletitle">单据状态：{{item.pbillstatus}}</span> -->
              <!-- <span class="fr tabletitle">调整总数：{{item.nnjum}}</span> -->
            </th>
          </tr>
          <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px" v-show="item.listshow =='N'">
            <th style="width:">行号</th>
            <th style="width:" v-for="head in tableHeads">{{ head.label }}</th>
            <!-- <th style="width:" >修改</th> -->
            <!-- <th style="width:">删除</th> -->
          </tr>
          <tr class="trbg" v-for="(data,index2) in item.productList" :key="item.period" v-show="item.listshow =='N'">
            <td style="border: 1px solid #56B8AA; height: 38px;">{{data.crowno}}</td>
            <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px;">
              <span>{{data[head.key]}}</span>
            </td>
            <!-- <td style="border: 1px solid #56B8AA; height: 38px;width:8%">
								<el-button type="warning" class="" size="mini" @click="modify(index,index2,item.vbillcode)">修改</el-button>
                            </td> -->
            <!--   <td style="border: 1px solid #56B8AA; height: 38px;width:8%">
                            	<el-button type="danger" class="" size="mini" @click="dellist(index,index2,item.vbillcode)">删除</el-button>
                            </td> -->
          </tr>
        </table>
      </div>
      <!-- tablelist end -->
      <!-- fenye start -->
      <div class="block" style="text-align: center;margin:20px auto ">
        <span>
				    <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
				      :current-page="page"
				      :page-size="pagesize"
				      layout="total, sizes, prev, pager, next, jumper"
				      :total="count">
				    </el-pagination>
				    </span>
      </div>
      <!-- fenye end -->
      <!-- <Modal start -->
     <!--  <div class="model" v-show="diaoboshow">
        <div class="content">
          <div class="title">
            <span class="fl">修改调整信息</span>
            <span class="fr" @click="closemodel"><i class="iconfont icon-guanbi"></i></span>
          </div>
          <div class="inputtext">
            <el-form :inline="true" :model="tableinput" class="demo-form-inline clearfix" ref="conditions">
              <el-form-item label="调出货位：" prop="coutspaceid" class="tinp">
                <el-input v-model="tableinput.coutspaceid" placeholder="请输入调出货位" prefix-icon="el-icon-edit" clearable></el-input>
              </el-form-item>
              <el-form-item label="调入货位：" prop="cinspaceid" class="tinp">
                <el-input v-model="tableinput.cinspaceid" placeholder="请输入调入货位" prefix-icon="el-icon-edit" clearable></el-input>
              </el-form-item>
              <el-form-item label="修改时间：" class="tinp">
                <el-date-picker v-model="tableinput.modifiedtime" type="date" placeholder="选择日期" @change="onchange">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="修改人：" class="tinp labelp">
                <el-input v-model="tableinput.modifier" placeholder="请输入修改人" prefix-icon="el-icon-edit" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="tablebox shou clearfix" style="margin-top:0">
            <table style="width: 54rem">
              <tr>
                <th style="border: 1px solid #56B8AA;width:105px" v-for="head in tableHeads">{{ head.label }}</th>
              </tr>
              <tr>
                <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; width:105px">
                  <el-input class="tabinp" v-model="tableData[head.key]" clearable></el-input>
                </td>
              </tr>
            </table>
            <el-button type="primary" class="mobut fr" @click="sumbittable">确认提交</el-button>
          </div>
        </div>
      </div> -->
      <!-- <Modal start -->
    </div>
    <!-- model end -->
    <div class=""  v-loading.fullscreen.lock="fullscreenLoading"></div>
    <!-- 弹窗 start --> 
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel> 
  </div>
</template>
<script>
// import { getElementsByClassName } from '../../../static/js/cookie.js' 
export default {
  name: '',
  data() {
    return {
      flag:false,
      msgShow:false,
      modelFlag:false,
      butflag:true,
      msg:'', 
      butmsg:'确认', 
      methodName:'', 
      utilpath: '',
      fullscreenLoading: false,
      InterfacePath: '',
      positionList: [],
      page: 1,
      pagesize: 10,
      count: 0,
      id: '',
      tableListid: '',
      index: 0,
      row: 0,
      changebgcolor: -1,
      user: {},
      showicon: false,
      diaoboshow: false,
      status: [{
          label: '已保存',
          value: 0
        },
        {
          label: '已提交',
          value: 1
        },
        {
          label: '已审核',
          value: 2
        }
      ],
      conditions: {
        outpositioncode: '',
        outpositionname: '',
        inpositioncode: '',
        inpositionname: '',
      },
      tableList: [],
      tableData: {},
      tableinput: {},
      tableHeads: [
        // {
        //        label: '调入仓库',
        //        key: 'cinstordocid'
        //    },
        {
          label: '调出货位',
          key: 'houtpositionname'
        },
        {
          label: '商品编码',
          key: 'productCode'
        },
        {
          label: '商品名称',
          key: 'productName'
        },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        },
        {
          label: '主单位',
          key: 'cunitName'
        },
        // {
        //     label: '批次号',
        //     key: 'vbatchcode'
        // },
        {
          label: '调出数量',
          key: 'nnum'
        },
        {
          label: '调入货位',
          key: 'hinpositionname'
        }
      ]
    }
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  destroyed() {
    sessionStorage.removeItem("vbillcode");
    sessionStorage.removeItem("billmaker");
    sessionStorage.removeItem("pk_product");
    sessionStorage.removeItem("time");
    sessionStorage.removeItem("page");
    sessionStorage.removeItem("pagesize");
    sessionStorage.removeItem("diaobolist");
    //console.log("清除session");
  },
  methods: {
     exportlist() {
      this.$router.push({path:'/ui/stock/exportlist',query:{pageFlag:1}});
    },
  	returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
             //console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                //console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    }else{
                        this.modelFlag = true;
                        this.methodName = 'message';
                        this.msg = res.data.message;
                        this.butflag =false;
                        this.butmsg='知道了'; 
                    }
                }, (err) => {
                      this.modelFlag = true;
                      this.msgShow =false;
                      this.methodName = 'message';
                      this.msg = '连接获取盘点单接口失败'+err;
                      this.butflag =false;
                      this.butmsg='知道了'; 
                })
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    //显示隐藏表格
    showlist(item, index) {
     // console.log("展开方法"); 
      // 取反(true或false)
      this.tableList[index].listshow = item.listshow == 'Y' ? 'N' : 'Y';  
        this.index1 = index;
        this.tableListid = item.vbillcode;
        this.toTop();   
      sessionStorage.setItem("diaobolist", JSON.stringify(this.tableList));
    },
    toTop() {
      var idmsg = ''
      if (this.tableListid != '') {
        idmsg = this.tableListid;
       // console.log("-=-=-=-=-=-=--=-:" + idmsg);
      } else {
        idmsg = 'contain';
        //console.log("-=-=-=-=-=-=--=-:" + idmsg);
      }
      //参数i表示间隔的幅度大小，以此来控制速度
      var dis = (document.getElementById(idmsg).scrollTop) / 8
      this.step += dis;
      document.getElementById(idmsg).scrollTop -= dis;
      var scroll = document.getElementById(idmsg).scrollTop;
      if (scroll > 0) {
        //console.log("回到顶部循环内" + document.getElementById(idmsg).scrollTop);
        // this.step+=dis
        var c = setTimeout(() => this.toTop(), 16);
      } else {
        clearTimeout(c);
      }
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pagesize = val;
      this.page=1; 
      this.getList();
      //console.log(this.pagesize);
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.page = val;
      //console.log(this.page);
      this.getList();
    },
    addlist() {
      this.$router.push({ path: '/ui/stock/huowei/zengwei' });
    },
    dellist(index, index2, id) {
      this.$confirm('此操作将永久删除该调整单，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var reqparam = {
          vbillcode: id,
          crowno: index2
        }
        this.$http.post('api/applybill', reqparam).then((res) => {
          // this.$http.post('api/applybill',reqparam).then((res)=>{
          if (res.data.status == '0') {
            this.tableList[index].productList.splice(index2, 1);
            sessionStorage.setItem("diaobolist", JSON.stringify(this.tableList));
            this.count = this.tableList.length;
            this.$message({
              showClose: true,
              message: '删除成功！',
              type: 'succcess'
            });
          } else {
            this.$message({
              showClose: true,
              message: '删除失败!',
              type: 'error'
            });
          }
        }, (err) => {
          this.$message({
            showClose: true,
            message: '命令提交失败!',
            type: 'error'
          });
          console.log(err);
        })
      }).catch(() => {
        this.$message({
          showClose: true,
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    cleandataicon() {
      //console.log("划过");
      if (this.conditions.time != '') {
        this.showicon = !this.showicon;
      }
      if (this.conditions.time == null) {
        this.showicon = false;
      }
    },
    selectchange1(value) {
      //console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
      //console.log("下拉变化事件2" + value.position_code);
      this.conditions.houtpositioncode = value.positioncode;
      this.conditions.houtpositionname = value.positionname;
      this.page=1;
      // this.getList();
    },
    selectchange2(value) {
      this.page=1;
      //console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
      //console.log("下拉变化事件2" + value.position_code);
      this.conditions.hinpositioncode = value.positioncode;
      this.conditions.hinpositionname = value.positionname;
      // this.getList();
    },
    getposition() {
      //获取数据接口
      var reqParam = {
        storecode: this.user.storecode
      };
      //console.log("建立了")
      //this.$http.get('api/position').then((res) => {
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          //var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          //console.log("打印货位" + JSON.stringify(this.positionList));
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了'; 
        } 
      }, (err) => {
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = '连接获取盘点单接口失败'+err;
          this.butflag =false;
          this.butmsg='知道了'; 
      });
    },
    //获取数据
    getList() {
      this.fullscreenLoading = true;
      let reqParam = {
        pageNum: this.page, //当前页
        pageSize: this.pagesize, //页面数据条数
        storecode: this.user.storecode,
        hinpositioncode: this.conditions.hinpositioncode,
        houtpositioncode: this.conditions.houtpositioncode 
      }
      sessionStorage.setItem("page", this.page);
      sessionStorage.setItem("pagesize", this.pagesize);
      //console.log("调用接口");
      //获取数据接口 
      // this.$http.post(this.InterfacePath+'/selectBilladjustment', reqParam,{emulateJSON:true}).then((res) => {
      this.$http.post(this.utilpath + '/selectBilladjustment', reqParam, { emulateJSON: true ,_timeout:600}).then((res) => {
        // this.$http.post('/ktnapi/selectBilladjustment', reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          this.fullscreenLoading = false;
          this.tableList = res.data.resultList;
          this.count = res.data.countNum; 
          sessionStorage.setItem("diaobolist", JSON.stringify(this.tableList));
        } else if (res.data.status == '-1') {
          this.fullscreenLoading = false;
          this.tableList = [];
          this.count = res.data.countNum;
          this.$message({
            showClose: true,
            type: 'info',
            message: '暂无数据'
          })
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {

            this.fullscreenLoading = false;
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了'; 
        } 
      }, (err) => {
        this.fullscreenLoading = false;
        this.msgShow =false;
        this.modelFlag = true;
        this.methodName = 'message';
        this.msg = '连接获取货位调整单接口失败'+err;
        this.butflag =false;
        this.butmsg='知道了'; 
      });
    },
    // 
    changerpwcolor(index) {
      this.changebgcolor = index;
    },
    init() { 
      this.user = JSON.parse(window.localStorage.getItem("userInfo")); 
      this.getposition();
      // this.getList(); 
    },
    modify(index, index2, id) {
      this.id = id;
      this.index = index;
      this.row = index2;
      this.tableData = this.tableList[index].productList[index2];
      this.tableinput = this.tableList[index];
      this.tableinput.modifiedtime = '';
      this.diaoboshow = true;
    },
    closemodel() {
      this.diaoboshow = false;
      this.tableData = {};
      this.tableinput = {};
    },
    sumbittable() {
      var reqParam = {
        vbillcode: this.id,
        crowno: this.row,
        tableData: this.tableData
      };
      this.$http.post("api/goods", reqParam).then((res) => {
        if (res.data.status == '0') {
          this.diaoboshow = false;
          this.$message({
            showClose: true,
            type: 'succcess',
            message: '修改成功'
          })
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: '修改失败'
          })
        }
      }, (err) => {
        //console.log(err);
        this.$message({
          showClose: true,
          type: 'error',
          message: '修改数据提交失败'
        })
      });
      this.tableData = {};
      this.tableinput = {};
    },
    onchange() {
      //console.log("打印时间" + this.tableinput.modifiedtime);
    },
    //搜索框变化事件
    onParamChange() {
      sessionStorage.setItem("diaobolist", JSON.stringify(this.tableList));
      this.page = 1;
      this.getList();
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/stock/huowei3.vue